import { getAppConfig } from '../../shared';
let appInsightsInstance;
let reactAppInstance;
let appInsightsConnectionString;
const makeSingleton = (initial) => {
    let value = initial;
    return {
        getValue: () => value,
        setValue: (valueToSet) => (value = valueToSet),
    };
};
const getAppInsights = (initial) => {
    if (!appInsightsInstance) {
        appInsightsInstance = makeSingleton(initial);
        return appInsightsInstance;
    }
    if (initial) {
        throw Error('Application Insights already initialised');
    }
    return appInsightsInstance;
};
const getReactPlugin = (initial) => {
    if (!reactAppInstance) {
        reactAppInstance = makeSingleton(initial);
        return reactAppInstance;
    }
    return reactAppInstance;
};
const getSharedAppInsightsConnectionStringByEnv = (env) => {
    if (env === 'prd') {
        return 'InstrumentationKey=5527fcc7-24b8-4b18-8862-fa672a7ae699;IngestionEndpoint=https://canadacentral-1.in.applicationinsights.azure.com/;LiveEndpoint=https://canadacentral.livediagnostics.monitor.azure.com/;ApplicationId=3c39e0b5-8be0-444f-9563-1fbbcb3a447f';
    }
    else {
        return 'InstrumentationKey=7b014a97-453a-4f58-8d3b-cc2fda4680c5;IngestionEndpoint=https://canadacentral-1.in.applicationinsights.azure.com/;LiveEndpoint=https://canadacentral.livediagnostics.monitor.azure.com/;ApplicationId=49186d90-482c-4041-9a1f-1d75532f1327';
    }
};
const getSharedAppInsightsConnectionString = () => {
    if (!appInsightsConnectionString) {
        const config = getAppConfig();
        appInsightsConnectionString = makeSingleton(getSharedAppInsightsConnectionStringByEnv(config.REACT_APP_ENV));
        return appInsightsConnectionString;
    }
    return appInsightsConnectionString;
};
export { getAppInsights, getReactPlugin, getSharedAppInsightsConnectionString };
